import { render, staticRenderFns } from "./checkboxList.vue?vue&type=template&id=57019598&scoped=true&"
import script from "./checkboxList.vue?vue&type=script&lang=js&"
export * from "./checkboxList.vue?vue&type=script&lang=js&"
import style0 from "./checkboxList.vue?vue&type=style&index=0&id=57019598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57019598",
  null
  
)

export default component.exports